import type { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

interface UploadButtonProps {
  icon?: React.ReactNode;
  label?: string;
  name: string;
  fileTypesAccepted: string;
  multipleFiles?: boolean;
  customStyle?: string;
  disabled?: boolean;
  changeHandler: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
}
function UploadButton({ icon, label, name, fileTypesAccepted, multipleFiles, customStyle, disabled, changeHandler }: UploadButtonProps) {
  return (
    <div className={twMerge(['cursor-pointer relative flex items-center', customStyle])}>
      <input
        type='file'
        name={name}
        className='absolute w-full h-full cursor-pointer rounded-md opacity-0'
        accept={fileTypesAccepted}
        multiple={multipleFiles}
        disabled={disabled}
        onChange={changeHandler}
      />
      <div className='px-4 py-2 w-full h-full flex gap-2'>
        {icon} {label}
      </div>
    </div>
  );
}
export default UploadButton;
